import { render, staticRenderFns } from "./MenuItemLabel.vue?vue&type=template&id=16be2b3a&scoped=true&"
import script from "./MenuItemLabel.vue?vue&type=script&lang=js&"
export * from "./MenuItemLabel.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemLabel.vue?vue&type=style&index=0&id=16be2b3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be2b3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
